import {Component, Inject, Input, LOCALE_ID, OnDestroy, OnInit} from '@angular/core';
import {KlinikaxpPaymentRequiredReservation} from "../../models/klinikaxp-payment-required-reservation.model";
import {UserService} from "../../providers/user.service";
import {AppStateService} from "../../providers/app-state.service";
import {CommonUtils} from "../../utils/common";
import {
  KlinikaxpPaymentRequiredReservationService
} from "../../providers/klinikaxp-payment-required-reservation.service";
import {ModalController} from "@ionic/angular";
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {mobilePhoneNumberValidator, timeValidator} from "../../utils/form-validators";
import {Doctor, VetClinicData, VisitType} from "../../models/vet-clinic-data.model";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {Observable, of, Subscription} from "rxjs";
import {catchError} from "rxjs/operators";
import {VetDoctorVetVisitTypeService} from "../../providers/vet-doctor-vet-visit-type.service";

@Component({
  selector: 'app-klinikaxp-payment-modal',
  templateUrl: './klinikaxp-payment-modal.component.html',
  styleUrls: ['./klinikaxp-payment-modal.component.scss'],
})
export class KlinikaxpPaymentModalComponent implements OnInit, OnDestroy {

  @Input()
  klinikaxpPaymentRequiredReservation: KlinikaxpPaymentRequiredReservation;
  @Input() title: string;
  @Input() vetcodeId: string;
  @Input() serverTime: string;
  @Input() smsEnabled: boolean;
  sendSMS: boolean;
  smsBalanceTooSmall: boolean = false;
  credentialNotProvided: boolean = false;
  smsServerBalanceCheckSub: Subscription;
  sendEmail: boolean = true;
  xpReservationGroup: FormGroup;
  isBusy: boolean;
  hasUnsavedChanges: boolean;
  vetClinicData: VetClinicData;
  visitTypes: VisitType[];
  visitTypeId: number;
  chosenVisitType: VisitType;
  isMedicalProcedure: boolean;
  price: string;
  dateToPrepaid: string;
  doctor: Doctor;
  canBeParsed: boolean;
  isBusySub: Subscription;
  vetClinicSub: Subscription;
  klinikaxpPaymentResquredReservationServiceSub: Subscription;
  showForm: boolean = false;
  minDate: string;
  minDateinDateType: Date;
  fullPrepaidDate: Date;
  timeToPrepaid: string;
  minMinutes: number;
  maxDateInDate: Date;
  maxDate: string;
  reservationEndTimeString: string;
  calendarChanged: boolean = false;
  datePreviousSelected: string;
  regex = new RegExp('^\\d+(\\.\\d{1,2})?$');
  decimalPlacesRegex = new RegExp('^\\d+(\\.\\d{2})');
  minMedicalProcedurePrice = 10;
  private alertPresented: boolean;
  private klinikaxpPaymentRequiredReservationTime: number;
  vetDoctorVetVisitTypeUUID: string;

  constructor(private userService: UserService, private appStateService: AppStateService, private commonUtils: CommonUtils,
              private klinikaxpPaymentResquredReservationService: KlinikaxpPaymentRequiredReservationService, private modalController: ModalController,
              private formBuilder: FormBuilder, private vetClinicService: VetClinicService, @Inject(LOCALE_ID) private locale: string) {
  }

  ngOnDestroy(): void {
    if (this.isBusySub) {
      this.isBusySub.unsubscribe();
    }
    if (this.vetClinicSub) {
      this.vetClinicSub.unsubscribe();
    }
    if (this.klinikaxpPaymentResquredReservationServiceSub) {
      this.klinikaxpPaymentResquredReservationServiceSub.unsubscribe();
    }
    if (this.smsServerBalanceCheckSub) {
      this.smsServerBalanceCheckSub.unsubscribe();
    }
  }

  ngOnInit() {
    this.canBeParsed = this.checkIfCanParse();

    this.isBusySub = this.appStateService.isBusySubject.subscribe(e => {
      this.isBusy = e;
    });

    let secBetweenDates = new Date(this.klinikaxpPaymentRequiredReservation?.endDate)?.getTime() * 0.001 - new Date(this.klinikaxpPaymentRequiredReservation?.startDate)?.getTime() * 0.001;
    if (secBetweenDates) {
      this.klinikaxpPaymentRequiredReservationTime = secBetweenDates / 60;
    }

    this.appStateService.updateIsBusySubject(true);
    this.vetClinicSub = this.vetClinicService.vetClinicData(this.klinikaxpPaymentRequiredReservation.vetcodeId).subscribe(async e => {

        this.minMinutes = e.paidBookingLockMinutes;
        console.log(this.minMinutes);
        this.minDateinDateType = new Date(new Date(this.serverTime).getTime());

        if (this.minMinutes) {
          this.minDateinDateType = new Date(this.minDateinDateType.getTime() + this.minMinutes * 60000); // dodanie minMinutes
        } else {
          this.minDateinDateType = new Date(this.minDateinDateType.getTime() + 3600000); // dodanie 1h
        }

        this.minDateinDateType = new Date(this.minDateinDateType.getTime() - (this.minDateinDateType.getSeconds() * 1000) - this.minDateinDateType.getMilliseconds()); // usunięcie sekund i milisekund z daty
        this.minDate = this.commonUtils.dateToYearMonthDayString(this.minDateinDateType);
        this.dateToPrepaid = this.minDate;
        console.log(this.dateToPrepaid);
        this.datePreviousSelected = this.minDate;
        this.timeToPrepaid = this.getDefaultTimeToPrepaid(this.minDateinDateType);
        this.maxDateInDate = new Date(new Date(this.klinikaxpPaymentRequiredReservation.startDate).getTime());
        this.maxDate = this.commonUtils.dateToYearMonthDayString(this.maxDateInDate);
        const prepaidDateTimestamp = Date.parse(this.dateToPrepaid.concat('T', this.timeToPrepaid, ':00'));
        this.fullPrepaidDate = new Date(prepaidDateTimestamp);

        this.showForm = true;
        this.appStateService.updateIsBusySubject(false);
        this.vetClinicData = e;
        this.doctor = e.doctors.filter(e => e.doctorId === this.klinikaxpPaymentRequiredReservation.doctorId)[0];
        this.getDoctorVisitTypes(this.klinikaxpPaymentRequiredReservation.doctorId).subscribe(visitTypes => {
          this.visitTypes = visitTypes.filter(visitType => visitType.prepaidRequired);
        });
        this.xpReservationGroup = this.formBuilder.group({
          userFirstName: ['', [Validators.required, this.noWhitespaceValidator]],
          userLastName: ['', [Validators.required, this.noWhitespaceValidator]],
          userPhoneNumber: ['', [Validators.required, mobilePhoneNumberValidator, this.noWhitespaceValidator]],
          petName: ['', [Validators.required, this.noWhitespaceValidator]],
          email: ['', [Validators.required, Validators.email, this.noWhitespaceValidator]],
          timeToPrepaid: [this.timeToPrepaid, [Validators.required, timeValidator]],
          linkNotes: [''],
        });
        console.log(this.minDateinDateType.toJSON());
        this.xpReservationGroup.markAllAsTouched();
      }, error => {
        this.commonUtils.presentAlertToast('Wystąpił błąd podczas pobierania danych');
        this.appStateService.updateIsBusySubject(false);
        this.onClose();
      }
    );
    if (this.smsEnabled) {
      this.smsServerBalanceCheckSub = this.vetClinicService.checkSmsServerBalance(this.klinikaxpPaymentRequiredReservation.vetcodeId).subscribe(r => {
        this.sendSMS = r;
        if (this.sendSMS !== true) {
          this.smsBalanceTooSmall = true;
        }
      }, error => {
        if (error && error.message) {
          if (error.message === 'CREDENTIAL_NOT_PROVIDED') {
            this.sendSMS = false;
            this.credentialNotProvided = true;
          }

          if (error.message === 'FUNDS_NOT_AVAILABLE') {
            this.sendSMS = false;
            this.smsBalanceTooSmall = true;
          }
        } else {
          this.sendSMS = false;
        }
      });
    }
  }

  noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : {'whitespace': true};
  }

  checkIfCanParse() {
    let opis = this.klinikaxpPaymentRequiredReservation.opis;
    let str = opis.split(',');
    if (str.length === 5 || str.length === 6) {
      if (str[3].trim().match('^[0-9]')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  onClose() {
    this.modalController.dismiss();
  }

  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChanges = true;
    }
  }

  hasPrepaidRequired(doctor: Doctor): boolean {
    return doctor && doctor.prepaidRequired && doctor.prepaidVisitPrice !== undefined;
  }

  paymentForVisitRequired(visitType: VisitType): boolean {
    return (visitType && (visitType.prepaidRequired && visitType.prepaidPrice && visitType.prepaidPrice > 0));

  }


  calculateBookingPrice(visitType): number {
    let price = 0;

    if (this.hasPrepaidRequired(this.doctor)) {
      price += this.doctor.prepaidVisitPrice;
    }

    if (this.paymentForVisitRequired(visitType)) {
      price += visitType.prepaidPrice;
    }

    return price;
  }

  changeCalendarValue($event) {
    const dateSplited = $event;
    if (dateSplited === this.datePreviousSelected.split("T")[0]) {
      this.calendarChanged = true;
    } else {
      this.calendarChanged = true;
      this.dateToPrepaid = dateSplited;
      const dateSplitedInDate = new Date(dateSplited);
      if ((dateSplitedInDate.getDate() === this.minDateinDateType.getDate())
        && (dateSplitedInDate.getMonth() === this.minDateinDateType.getMonth())) {
        this.timeToPrepaid = this.getDefaultTimeToPrepaid(this.minDateinDateType);
        this.xpReservationGroup.get('timeToPrepaid').setValue(this.timeToPrepaid);
      } else if ((dateSplitedInDate.getDate() === this.maxDateInDate.getDate())
        && (dateSplitedInDate.getMonth() === this.maxDateInDate.getMonth())) {
        this.timeToPrepaid = this.getDefaultTimeToPrepaid(new Date(this.maxDateInDate.getTime() - 3600000));
        this.xpReservationGroup.get('timeToPrepaid').setValue(this.timeToPrepaid);
      } else {
        this.timeToPrepaid = '23:59';
        this.xpReservationGroup.get('timeToPrepaid').setValue(this.timeToPrepaid);
      }
      this.timeToPrepaid = this.xpReservationGroup.get('timeToPrepaid').value;

      const prepaidDateTimestamp = Date.parse(this.dateToPrepaid.concat('T', this.timeToPrepaid, ':00'));
      this.fullPrepaidDate = new Date(prepaidDateTimestamp);
    }
    this.datePreviousSelected = $event;
  }

  getFullPrepaidDate() {
    return this.fullPrepaidDate;
  }

  getDefaultTimeToPrepaid(date: Date) {
    const hour: number = date.getHours();
    const minute: number = date.getMinutes();
    let hourString: string = hour.toString();
    let minuteString: string = minute.toString();

    if (hour < 10) {
      hourString = '0'.concat(hourString);
    }
    if (minute < 10) {
      minuteString = '0'.concat(minuteString);
    }
    return hourString.concat(':', minuteString);
  }

  onEdit() {
    if (this.xpReservationGroup.valid) {
      this.timeToPrepaid = this.xpReservationGroup.get('timeToPrepaid').value;
      const prepaidDateTimestamp = Date.parse(this.dateToPrepaid.concat('T', this.timeToPrepaid, ':00'));
      if (prepaidDateTimestamp >= this.commonUtils.dateFromString(this.minDate).getTime()) {
        if (((this.isMedicalProcedure && this.price && !isNaN(+this.price.replace(',', '.')) && Number.parseFloat(this.price.replace(',', '.')) >= 10)
          || !this.isMedicalProcedure && this.visitTypeId) && this.dateToPrepaid) {
          this.appStateService.updateIsBusySubject(true);
          this.commonUtils.presentYesNoActionSheet('Na pewno chcesz wysłać na podany adres email link do płatności?',
            'Tak', 'Nie', 'checkmark', 'close', () => {
              if (this.xpReservationGroup.contains('medicalProcedurePrice')) {
                this.xpReservationGroup.removeControl('medicalProcedurePrice');
              }
              let obj = this.commonUtils.formGroupValuesToObject<KlinikaxpPaymentRequiredReservation>(new KlinikaxpPaymentRequiredReservation(),
                this.xpReservationGroup);
              if (obj) {
                this.klinikaxpPaymentRequiredReservation.userFirstName = obj.userFirstName;
                this.klinikaxpPaymentRequiredReservation.userLastName = obj.userLastName;
                this.klinikaxpPaymentRequiredReservation.userPhoneNumber = obj.userPhoneNumber;
                this.klinikaxpPaymentRequiredReservation.petName = obj.petName;
                this.klinikaxpPaymentRequiredReservation.email = obj.email;
                this.klinikaxpPaymentRequiredReservation.linkNotes = obj.linkNotes;
                this.klinikaxpPaymentRequiredReservation.sendEmail = this.sendEmail;
                this.klinikaxpPaymentRequiredReservation.vetDoctorVetVisitTypeUUID = this.vetDoctorVetVisitTypeUUID;
                if (this.smsEnabled) {
                  this.klinikaxpPaymentRequiredReservation.sendSMS = this.sendSMS;
                }
                if (this.visitTypeId && !this.isMedicalProcedure) {
                  this.klinikaxpPaymentRequiredReservation.visitTypeId = this.visitTypeId;
                  let amount = this.visitTypes.filter(e => e.visitTypeId == this.visitTypeId).map(s => this.calculateBookingPrice(s))[0];
                  this.klinikaxpPaymentRequiredReservation.amount = amount;
                }

                if (this.isMedicalProcedure) {
                  this.klinikaxpPaymentRequiredReservation.isMedicalProcedure = true;
                } else {
                  this.klinikaxpPaymentRequiredReservation.isMedicalProcedure = false;
                }
                if (this.price && !isNaN(+this.price.replace(',', '.')) && this.isMedicalProcedure) {
                  let priceAsNumber = Number.parseFloat(this.price.replace(',', '.'));
                  console.log('priceAsNumber', priceAsNumber);
                  this.klinikaxpPaymentRequiredReservation.amount = priceAsNumber;
                }
                this.fullPrepaidDate = new Date(prepaidDateTimestamp);
                this.klinikaxpPaymentRequiredReservation.finalPaymentDate = this.commonUtils.date2StrLong(this.fullPrepaidDate);
                this.klinikaxpPaymentResquredReservationServiceSub = this.klinikaxpPaymentResquredReservationService.saveKlinikaXpPaymentRequredReservationInfo(this.klinikaxpPaymentRequiredReservation).subscribe(e => {
                  if (e) {
                    this.appStateService.updateIsBusySubject(false);
                    if (e.sendEmail && e.sendSMS) {
                      if (e.sendSMS && !e.smsId && e.emailId) {
                        this.commonUtils.presentInfoToast('Dane do płatności zostały wysłane tylko na adres email klienta');
                      }
                      if (e.sendEmail && !e.emailId && e.smsId) {
                        this.commonUtils.presentInfoToast('Dane do płatności zostały wysłane tylko przez SMS na wskazany numer klienta klienta');
                      }
                      if (e.emailId && e.smsId) {
                        this.commonUtils.presentInfoToast('Dane do płatności zostały wysłane do klienta');
                      }

                    } else {
                      if (e.emailId || e.smsId) {
                        this.commonUtils.presentInfoToast('Dane do płatności zostały wysłane do klienta');
                      } else {
                        this.commonUtils.presentAlertToast('Nie można przesłać danych do płatności klientowi');
                      }
                    }
                    this.modalController.dismiss();
                  } else {
                    this.appStateService.updateIsBusySubject(false);
                    this.commonUtils.presentAlertToast("Wystąpił bład podczas wysyłania danych do płatności");
                  }
                }, error => {
                  switch (error.message) {
                    case 'VETCODE_DATE_TEST_FAILED':
                      this.appStateService.updateIsBusySubject(false);
                      this.commonUtils.presentAlertToast('Sprawdź dane w klinice, pracownik nie jest dostępny w tych godzinach')
                      break;
                    case 'DATE_TEST_FAILED':
                      this.appStateService.updateIsBusySubject(false);
                      this.commonUtils.presentAlertToast('W danych godzinach istnieje już zarezerwowany termin')
                      break;
                    case 'TERMS_OF_AGREEMENT_NOT_FOUND':
                      this.appStateService.updateIsBusySubject(false);
                      this.commonUtils.presentAlertToast("Przepraszamy, wysyłanie linków nie jest możliwe bez wcześniejszego skonfigurowania regulaminu")
                      break;
                    case 'VET_DOCTOR_NOT_FOUND':
                      this.appStateService.updateIsBusySubject(false);
                      this.commonUtils.presentAlertToast("Ten termin nie ma przypisanego lekarza w Vetineo. Dodaj go do rezerwacji w Klinice Xp lub skontaktuj się z obsługa klienta - 456 456 114")
                      break;
                    case 'MESSAGE_NOT_SEND':
                      this.appStateService.updateIsBusySubject(false);
                      this.commonUtils.presentAlertToast("Nie wysłano wiadomości, przejdź do zakładki wysłane linki, wybierz termin, popraw dane kontaktowe i wyślij wiadomość");
                      this.modalController.dismiss();
                      break;
                    default:
                      this.appStateService.updateIsBusySubject(false);
                      this.commonUtils.presentAlertToast("Wystąpił bład podczas wysyłania danych do przelewu");
                      break;
                  }
                });
              }

            }, () => {
              this.appStateService.updateIsBusySubject(false);
            });
        } else {
          if (!this.dateToPrepaid) {
            this.commonUtils.presentAlertToast('Uzupełnij datę')
          }

          if (this.isMedicalProcedure && (!this.price || isNaN(+this.price.replace(',', '.')))) {
            this.commonUtils.presentAlertToast('Popraw cene vouchera')
          }
          if (this.isMedicalProcedure && this.price && !isNaN(+this.price.replace(',', '.')) && Number.parseFloat(this.price.replace(',', '.')) < 10) {
            this.commonUtils.presentAlertToast('Minimalna cena vouchera to 10 zł')
          }
        }
      } else {
        this.commonUtils.presentAlertToast('Zbyt mało czasu na dokonanie zapłaty, wymagane co najmniej ' + this.minMinutes + ' od teraz');
      }
    } else {
      this.commonUtils.presentAlertToast('Popraw błędy w formularzu');
    }

  }

  isFormFieldInvalid(formGroup: FormGroup, fieldName: string, validationType: string) {
    return this.commonUtils.isFormFieldInvalid(formGroup, fieldName, validationType);
  }

  onCancelEdit() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, chcesz anulować?',
        'Tak', 'Nie', 'checkmark', 'close', () => {
          this.onClose();
        }, () => {
        });
    } else {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno anulować wysyłanie informacji o płatności?',
        'Tak', 'Nie', 'checkmark', 'close', () => {
          this.onClose();
        }, () => {
        });
    }
  }

  onSelectVisitType($event) {
    this.chosenVisitType = this.visitTypes.find(visitType => visitType.visitTypeId === Number(this.visitTypeId));
    const reservationEndTime = new Date(new Date(this.klinikaxpPaymentRequiredReservation.startDate).getTime() + 60 * 1000 * this.chosenVisitType.countTime);
    this.reservationEndTimeString = this.commonUtils.date2StrLong(reservationEndTime);
    if (this.vetClinicData.useVetineoVisitTypes) {
      this.vetDoctorVetVisitTypeUUID = this.visitTypes.filter(e => e.visitTypeId == this.visitTypeId)[0]?.vetDoctorVetVisitTypeUUID;

    }

    this.isMedicalProcedure = false;
    if (this.xpReservationGroup.contains('medicalProcedurePrice')) {
      this.xpReservationGroup.removeControl('medicalProcedurePrice');
    }

    if (this.klinikaxpPaymentRequiredReservationTime) {
      let visitType = this.visitTypes.filter(e => e.visitTypeId == this.visitTypeId)[0];
      if (visitType) {
        if (visitType.countTime != this.klinikaxpPaymentRequiredReservationTime) {
          this.commonUtils.presentInfoToast('Czas wybranego typu wizyty jest inny niż ten zaznaczony wcześniej w klinice')
        }
      }
    }
  }

  parseOpisAndFillTheForm() {
    this.canBeParsed = false;
    let opis = this.klinikaxpPaymentRequiredReservation.opis;
    let str = opis.split(',');

    if (this.xpReservationGroup.contains('userFirstName')) {
      this.xpReservationGroup.get('userFirstName').setValue(str[0].trim());
    }
    if (this.xpReservationGroup.contains('userLastName')) {
      this.xpReservationGroup.get('userLastName').setValue(str[1].trim());
    }
    if (this.xpReservationGroup.contains('userPhoneNumber')) {
      this.xpReservationGroup.get('userPhoneNumber').setValue(str[3].trim());

    }
    if (this.xpReservationGroup.contains('petName')) {
      this.xpReservationGroup.get('petName').setValue(str[2].trim());

    }
    if (this.xpReservationGroup.contains('email')) {
      this.xpReservationGroup.get('email').setValue(str[4].trim());
    }

    this.commonUtils.presentInfoToast('Sprawdź czy dane wypełniły się poprawnie i uzupełnij typ wizyty')
  }

  toggleIsMedicalProcedure(event: CustomEvent) {
    if (event && event.detail) {
      this.isMedicalProcedure = event.detail?.checked;
    }
    if (this.isMedicalProcedure) {
      this.xpReservationGroup.addControl('medicalProcedurePrice', new FormControl('', [Validators.required, this.priceValidator.bind(this)]));
    } else {
      if (this.xpReservationGroup.contains('medicalProcedurePrice')) {
        this.xpReservationGroup.removeControl('medicalProcedurePrice');
      }
    }
  }

  checkIfTimeIsValid() {
    if (this.xpReservationGroup.controls.timeToPrepaid.valid) {
      this.timeToPrepaid = this.xpReservationGroup.get('timeToPrepaid').value;
      const prepaidDateTimestamp = Date.parse(this.dateToPrepaid.concat('T', this.timeToPrepaid, ':00'));
      const fullDate = new Date(prepaidDateTimestamp);
      if (fullDate < this.minDateinDateType || (fullDate > new Date(new Date(this.klinikaxpPaymentRequiredReservation.startDate)))) {
        this.xpReservationGroup.controls.timeToPrepaid.setErrors({time: true});
      } else {
        this.fullPrepaidDate = new Date(prepaidDateTimestamp);
      }
    }
  }

  priceValidator(control: AbstractControl) {
    const value = control.value;
    const isValid = (value >= this.minMedicalProcedurePrice) && this.regex.test(value);
    return isValid ? null : {price: true};
  }

  numberExtraction($event: any) {
    let eventString: string = $event.detail.value.replace(/,/g, '.');
    eventString = eventString.replace(/^0\d+/g, '0');
    eventString = eventString.replace(/^\./g, '');
    eventString = eventString.replace(/\.\d*\./g, '.');
    eventString = eventString.replace('-', '');
    eventString = eventString.replace(/[^\d.]/g, '');
    this.xpReservationGroup.get('medicalProcedurePrice').setValue(eventString);
    if (eventString.match(this.decimalPlacesRegex)) {
      this.xpReservationGroup.get('medicalProcedurePrice').setValue(eventString.match(this.decimalPlacesRegex)[0]);
    }

    const pr = this.xpReservationGroup.get('medicalProcedurePrice').value as number;
    if (isNaN(pr)) {
      this.handleAlert('Podaj wartość liczbową');
    }
    this.price = this.xpReservationGroup.get('medicalProcedurePrice').value;
  }

  handleAlert(alertString: string) {
    if (!this.alertPresented) {
      this.commonUtils.presentAlertToast(alertString);
      this.alertPresented = true;
      setTimeout(() => {
        this.alertPresented = false;
      }, 4000);
    }
  }

  getDoctorVisitTypes(doctorId: number): Observable<VisitType[]> {
    if (!this.vetClinicData) {
      return of([]);
    }

    return this.vetClinicService.getDoctorVisitTypes(doctorId, this.vetcodeId).pipe(
      catchError(error => {
        return of([]);
      })
    );
  }


  getMinutes(visitType: VisitType) {
    return visitType.countTime;
  }

  getReservationStartEndString() {
    return (this.isMedicalProcedure || !this.chosenVisitType) ?
      `${this.klinikaxpPaymentRequiredReservation.startDate} - ${this.klinikaxpPaymentRequiredReservation.endDate}` :
      `${this.klinikaxpPaymentRequiredReservation.startDate} - ${this.reservationEndTimeString}`;
  }
}
